import React from "react";
import Header from "./layout/header";
import Footer from "./layout/footer";
import CustomerBanner from "./CustomerBanner";
import CustomerInfo from "./CustomerInfo";
function AICustomerSupport() {
    return (
        <>
            <Header />
            <main>
                <CustomerBanner />
                <CustomerInfo />
            </main>
            <Footer />
        </>
    );
}

export default AICustomerSupport;
